<template>
<div>
  <div class="my-4">
    <h3>{{ msg.header }}</h3>
    <div :class="['alert', `alert-${msg.message.color}`]" role="alert">{{ msg.message.text }}</div>
    <small v-if="msg.message.small">{{ msg.message.small }}</small>
    <hr/>

    <div class="form-group mt-5">
      <div v-if="msg.message.color !== 'success'">
        <label for="email">Email:</label>
        <input  v-model="email" type="email" class="form-control mx-auto w-50" id="email" placeholder="Enter email address"/>
        <small></small>
      </div>
      <div class="m-5">
        <button v-if="msg.message.color !== 'success'" @click="forgotPass" type="submit" class="btn btn-primary btn-outline-white m-1 col-5 ">Send Email</button>
        <router-link v-else :to="{ name: 'login' }" type="submit" class="btn btn-primary btn-outline-white m-1 col-5 ">Go to Login</router-link>
      </div>
    </div>
  
  </div>
</div>
</template>

<script>

import Dashboard from '../pages/Dashboard'
import { auth } from '../firebase'

export default {
  name: "Forgot-Password",
  components: {
    Dashboard
  },
  data: () => ({
    msg: {
      header: "Forgot Password",
      message: {
        text: "An Email will be sent to you, click the link to reset your password",
        color: "warning",
        small: "Make sure to check your spam!"
      },
      routename: "login",
      routemsg: "Return to Login"
    },
    email: ""
  }),
  methods: {
    forgotPass(){
      auth.sendPasswordResetEmail(this.email).then(() => {
        // Email sent.
        this.msg.message = {
          text: "Email was Successfully Sent",
          color: "success",
        }
      }).catch((error) => {
        // An error happened.
        this.alert.message = {
          text: "Email Failed to Send",
          color: "danger",
        }
      });
      this.email = ""
    }
  } 
}
</script>